export default "__VITE_ASSET__BL101wts__"